import { FC, useEffect } from 'react'
import cn from 'classnames'

import ScrollTo from '@/components/ScrollTo'
import { IMessage } from '@/context/types'
import { SCROLL_TARGET_ID } from '@/context/constants'

import Message from './components/Message'

export interface MessageThreadProps {
  messages: IMessage[]
  className?: string
}

const MessageThread: FC<MessageThreadProps> = ({ messages, className }) => {
  useEffect(() => {
    const targetElement = document.getElementById(SCROLL_TARGET_ID)
    if (targetElement && messages.length) {
      targetElement.scrollIntoView({ behavior: 'auto' })
    }
  }, [messages])

  const renderMessages = () => {
    if (messages.length > 0) {
      return (
        <div className="pmui-overflow-x-hidden pmui-overflow-y-auto">
          {messages.map(message => {
            if (message.deleted) {
              return null
            }

            return <Message key={message.id} message={message} />
          })}
          <ScrollTo targetId={SCROLL_TARGET_ID} />
        </div>
      )
    }
    return null
  }

  return <div className={cn(className)}>{renderMessages()}</div>
}

export default MessageThread
